module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/profile-5b461975cb2310077cfe651b11303221.jpg";